import React from 'react';

import { Flex, Grid, Title } from '@mantine/core';
import { BehaviourOverview } from 'pages/GuestSmartAssistant/GuestDashboard/OverviewTab/BehaviourOverview';
import { InformationOverview } from 'pages/GuestSmartAssistant/GuestDashboard/OverviewTab/InformationOverview';
import { IntegrationsOverview } from 'pages/GuestSmartAssistant/GuestDashboard/OverviewTab/IntegrationsOverview';
import { MemoriesOverview } from 'pages/GuestSmartAssistant/GuestDashboard/OverviewTab/MemoriesOverview';
import { ResourcesOverview } from 'pages/GuestSmartAssistant/GuestDashboard/OverviewTab/ResourcesOverview';
import { ThemeOverview } from 'pages/GuestSmartAssistant/GuestDashboard/OverviewTab/ThemeOverview';
import { ToolsOverview } from 'pages/GuestSmartAssistant/GuestDashboard/OverviewTab/ToolsOverview';
import { useTranslation } from 'react-i18next';
import { SmartAssistant, SmartAssistantType } from 'shared/interfaces/SmartAssistant';

const THEME_OVERVIEW_SMART_ASSISTANT_TYPES = [SmartAssistantType.BASIC, SmartAssistantType.WEBSITE];

interface OverviewTabProps {
  smartAssistant: SmartAssistant;
}

export function OverviewTab({ smartAssistant }: OverviewTabProps) {
  const { t } = useTranslation();

  return (
    <Flex w="100%" h="100%" direction="column" gap={10} style={{ flex: 1, minHeight: 0, overflowX: 'hidden' }}>
      <Title order={4}>{t('SMART_ASSISTANT.OVERVIEW_SECTION.TITLE')}</Title>
      <Grid grow>
        <Grid.Col span={3}>
          <InformationOverview smartAssistant={smartAssistant} />
        </Grid.Col>
        <Grid.Col span={3}>
          <ResourcesOverview smartAssistant={smartAssistant} />
        </Grid.Col>
        <Grid.Col span={3}>
          <MemoriesOverview smartAssistant={smartAssistant} />
        </Grid.Col>
        <Grid.Col span={3}>
          {THEME_OVERVIEW_SMART_ASSISTANT_TYPES.includes(smartAssistant.type) ? (
            <ThemeOverview smartAssistant={smartAssistant} />
          ) : (
            <IntegrationsOverview smartAssistant={smartAssistant} />
          )}
        </Grid.Col>
      </Grid>
      <Flex direction="column" style={{ flex: 'unset' }} mih={125}>
        <BehaviourOverview smartAssistant={smartAssistant} />
      </Flex>
      <Flex direction="column" style={{ flex: 'unset' }} mah={300}>
        <ToolsOverview smartAssistant={smartAssistant} />
      </Flex>
    </Flex>
  );
}
